// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__35oLt","Success":"Button_Success__2-dnZ","Danger":"Button_Danger__1t70Z"};